import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { WithWorkspaceId } from '~/types/common';
import { dashboardWorkspaceApi } from '~/utils/api';

/**
 * The listing returns the full container_images rows, but the sdk's
 * ContainerImage type predates the image lifecycle columns - the ones the UI
 * reads are declared here until the sdk type catches up.
 */
export type WorkspaceContainerImage = RcInstanceDTO.ContainerImage & {
  deprecated_at?: string | null;
};

export const getAll = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardWorkspaceApi.get<WorkspaceContainerImage[]>(`/workspaces/${workspaceId}/images`);
